module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_a-function.js
// module id = 1474
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16